import { render, staticRenderFns } from "./list-book.vue?vue&type=template&id=58b6d576&scoped=true&"
import script from "./list-book.vue?vue&type=script&lang=js&"
export * from "./list-book.vue?vue&type=script&lang=js&"
import style0 from "./list-book.vue?vue&type=style&index=0&id=58b6d576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6d576",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VDataTable,VIcon})
